import React from 'react';
import { FontIcon, IconButton, RaisedButton } from 'material-ui';
import CheckCircle from 'material-ui/svg-icons/action/check-circle';
import { Link } from 'react-router';

export default ({ redirectLink }) => (
  <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
    <h1>You did it!</h1>
    <h4>Your push has been sent to its target audience</h4>
    <IconButton style={{ width: 224, height: 224 }} iconStyle={{ width: 192, height: 192 }}>
        <CheckCircle color="#4CAF50" />
    </IconButton>
     <Link to={redirectLink}><RaisedButton label="View Notifications" secondary/></Link>
  </div>
);


// WEBPACK FOOTER //
// ./src/components/createEditPush/Success.js